module.exports = __webpack_public_path__ + "std/img/download.63e9aad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build800/assets/image/download.jpg
// module id = VZrS
// module chunks = 0 14